import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { errors, paxRoute, sessionRequired } from "../../common";
import { ClaimCreditsResponse, SignupBudgetSpentData } from "./schemas";

const signupBudgetSpent = {
  SIGNUP_BUDGET_SPENT: {
    status: 503,
    message:
      "The free signup credits for this hour or day are spent. Claim again after data.retryAt.",
    data: SignupBudgetSpentData,
  },
} as const;

export const claimCredits = oc
  .meta(
    paxRoute({ auth: { kind: "session" }, minimumTier: "suspicious", cost: "write" }),
    openapi({
      method: "POST",
      path: "/api/accounting/v1alpha1/credits/claim",
      operationId: "accounting.credits.claim",
      summary: "Claim free credits.",
      description:
        "Tops the signup balance up to the guest or registered signup amount and, for an account whose refresh is due, claims the credit refresh. Signup credits need the suspicious tier or better and the refresh normal; an account short of either is asked for a step-up. The claim never calls Castle: the account was scored when its session was checked. Clients claim after every sign-in and when the app starts.",
      inputStructure: "detailed",
      successDescription: "What the claim granted.",
    }),
  )
  .errors({
    ...errors.badRequest,
    ...sessionRequired,
    FORBIDDEN: { message: "Staff acting as a player can't claim the player's credits." },
    NOT_FOUND: { message: "No player has that id." },
    CONFLICT: { message: "The player is closed." },
    ...signupBudgetSpent,
  })
  .output(ClaimCreditsResponse);
